import { ROLE_REQUIREMENT_REF_PREFIX } from './requirementRef.util'

// "role:<name>" is this domain's own sentinel prefix. The name is the match key for a custom
// directory role. Built-in role template ids stay as plain ids and are not requirement refs.
export const REQUIREMENT_REF_PREFIX = ROLE_REQUIREMENT_REF_PREFIX

export const isRequirementRef = (value) => typeof value === 'string' && value.startsWith(REQUIREMENT_REF_PREFIX)

export const getRequirementId = (value) => (isRequirementRef(value) ? value.slice(REQUIREMENT_REF_PREFIX.length) : null)

export const toRequirementRef = (requirementId) => `${REQUIREMENT_REF_PREFIX}${requirementId}`

export const DIRECTORY_ROLE_REQUIREMENT_STATUS = {
  MATCHED: 'matched',
  UNRESOLVABLE: 'unresolvable',
}
